import React from 'react';
import anna from '../assets/images/cast/anna.webp';
import armando from '../assets/images/cast/armando.webp';
import ayron from '../assets/images/cast/ayron.webp';
import barbara from '../assets/images/cast/barbara.webp';
import brandon from '../assets/images/cast/brandon.jpg';
import dennis from '../assets/images/cast/dennis.webp';
import diana from '../assets/images/cast/diana.jpeg';
import earle from '../assets/images/cast/earle.webp';
import janani from '../assets/images/cast/janani.webp';
import jamie from '../assets/images/cast/jamie.webp';
import jorge from '../assets/images/cast/jorge.webp';
import kira from '../assets/images/cast/kira.jpeg';
import kj from '../assets/images/cast/kj.webp';
import luke from '../assets/images/cast/luke.webp';
import mason from '../assets/images/cast/mason.webp';
import mico from '../assets/images/cast/mico.webp';
import mike from '../assets/images/cast/mike.webp';
import poesy from '../assets/images/cast/POESY2.webp';
import stevenD from '../assets/images/cast/steven.jpeg';
import stevenR from '../assets/images/cast/steven_r.jpg';
import tayla from '../assets/images/cast/tayla.webp';
import teagan from '../assets/images/cast/teagan.webp';
import tristan from '../assets/images/cast/tristan.webp';
import troy from '../assets/images/cast/troy.webp';
import wanda from '../assets/images/cast/wanda.webp';

import jorge_alt from '../assets/images/cast/tayla.webp' // Add your alternate image path here

const CastMember = ({ image, alternateImage, role, name, subtitle = '' }) => (
    <div className="flex flex-col items-center text-center mb-12">
      <div className="relative mb-4 group">
        {/* Cast Member Image */}
        <div className="w-48 h-48 overflow-hidden mb-4">
          <img 
            src={image} 
            alt={name}
            className={`w-full h-full object-cover object-top grayscale hover:grayscale-0 transition-all duration-500
              ${alternateImage ? 'group-hover:opacity-0' : ''}`}
          />
          
          {/* Alternate Image (Only for Jorge) */}
          {alternateImage && (
            <img 
              src={alternateImage} 
              alt={`${name} alternate`}
              className="w-full h-full object-cover object-top absolute inset-0 opacity-0 group-hover:opacity-100 transition-all duration-500"
            />
          )}
        </div>
        
        {/* Greek-inspired decorative border */}
        <div className="absolute inset-0 border border-white/20 -m-2 opacity-0 group-hover:opacity-100 transition-opacity duration-500"/>
      </div>
      
      {/* Role */}
      <div className="text-sm tracking-widest uppercase text-gray-400 mb-1">
        {role}
      </div>
      
      {/* Name */}
      <h3 className="text-xl tracking-wider uppercase mb-1">
        {name}
      </h3>
      
      {/* Subtitle if provided */}
      {subtitle && (
        <div className="text-sm tracking-wide text-gray-400">
          {subtitle}
        </div>
      )}
    </div>
  );

const CastPage = () => {
// Separate Jorge as the creator/lead
  const creator = {
    role: "ODYSSEUS, WINIONS, POLYPHEMUS, ENSEMBLE",
    name: "JORGE RIVERA-HERRANS",
    subtitle: "Creater of EPIC",
    image: jorge,
    alternateImage: jorge_alt
  };


  const castMembers = [
    {
      role: "SIRENS, PENELOPE",
      name: "ANNA LEA",
      image: anna
    },
    {
      role: "EURYLOCHUS, ENSEMBLE",
      name: "ARMANDO JULIAN",
      image: armando
    },
    {
      role: "PERIMEDES, ANTINOUS, ENSEMBLE",
      name: "AYRON ALEXANDER",
      image: ayron
    },
    {
      role: "CALYPSO",
      name: "BARBARA WANGUI",
      image: barbara
    },
    {
      role: "APOLLO",
      name: "BRANDON McINNIS",
      image: brandon
    },
    {
      role: "EURYMACHUS, ENSEMBLE",
      name: "DENNIS DIAZ",
      image: dennis
    },
    {
      role: "PRINCESS WINION",
      name: "DIANA RIVERA-HERRANS",
      image: diana
    },
    {
      role: "ARES, ENSEMBLE",
      name: "EARLE GRESHAM JR.",
      image: earle  // Placeholder until we get the correct image
    },
    {
      role: "MELANTHIUS, ENSEMBLE",
      name: "JAMIE WILTSHIRE",
      image: jamie
    },
    {
      role: "APHRODITE",
      name: "JANANI K. JHA",
      image: janani  // Placeholder until we get the correct image
    },
    {
      role: "ODYSSEUS, WINIONS, POLYPHEMUS, ENSEMBLE",
      name: "JORGE RIVERA-HERRANS",
      image: jorge
    },
    {
      role: "AEOLUS",
      name: "KIRA STONE",
      image: kira
    },
    {
      role: "SCYLLA",
      name: "KJ BURKHAUSER",
      image: kj
    },
    {
      role: "ZEUS, ELPENOR",
      name: "LUKE HOLT",
      image: luke  // Placeholder until we get the correct image
    },
    {
      role: "TIRESIAS",
      name: "MASON OLSHAVSKY",
      image: mason
    },
    {
      role: "TELEMACHUS",
      name: "MIGUEL VELOSO (MICO)",
      image: mico
    },
    {
      role: "HEPHAESTUS",
      name: "MIKE RIVERA",
      image: mike
    },
    {
      role: "HERA",
      name: "SARAH BOTELHO (POESY)",
      image: poesy
    },
    {
      role: "POLITES",
      name: "STEVEN DOOKIE",
      image: stevenD
    },
    {
      role: "POSEIDON",
      name: "STEVEN RODRIGUEZ",
      image: stevenR
    },
    {
      role: "CIRCE",
      name: "TAYLA SINDEL",
      image: tayla
    },
    {
      role: "ATHENA",
      name: "TEAGAN EARLEY",
      image: teagan
    },
    {
      role: "AMPHINOMUS, ENSEMBLE",
      name: "TRISTAN CALDWELL",
      image: tristan
    },
    {
      role: "HERMES, ENSEMBLE",
      name: "TROY DOHERTY",
      image: troy
    },
    {
      role: "ANTICLEA",
      name: "WANDA HERRANS",
      image: wanda
    }
    
  ];

  return (
    <div id="cast-page" className="bg-black text-white py-20">
      {/* Page Title */}
      <div className="text-center mb-20">
        <h1 className="text-5xl tracking-[0.3em] uppercase mb-6">
          Cast
        </h1>
        
        {/* Greek-inspired decorative divider */}
        <div className="flex items-center justify-center gap-4 px-4">
          <div className="h-px w-24 bg-gradient-to-r from-transparent via-white to-transparent"/>
          <div className="w-2 h-2 border border-white transform rotate-45"/>
          <div className="h-px w-24 bg-gradient-to-r from-white via-white to-transparent"/>
        </div>
      </div>

      {/* Creator Feature */}
      <div className="container mx-auto px-4 mb-24">
        <div className="max-w-md mx-auto">
          <CastMember {...creator} />
        </div>
        
        {/* Decorative divider */}
        <div className="flex items-center justify-center gap-4 px-4 mt-12">
          <div className="h-px w-48 bg-gradient-to-r from-transparent via-red-900/20 to-transparent"/>
        </div>
      </div>

      {/* Cast Grid */}
      <div className="container mx-auto px-4">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-x-8 gap-y-12">
          {castMembers.map((member, index) => (
            <CastMember key={index} {...member} />
          ))}
        </div>
      </div>
    </div>
  );
};

export default CastPage;